// src/components/ContactPage.jsx
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useEffect } from 'react';

const ContactPage = ({ setCurrentPage }) => {
   useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 可选：平滑滚动
  }, []);
  return (
    <div>
      <Header currentPage="contact" setCurrentPage={setCurrentPage} />

      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* 标题区域 */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">联系我们</h2>
            <div className="w-32 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-emerald-600 mx-auto rounded-full"></div>
            <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
              期待与您携手合作，共同推动云南新能源事业发展
            </p>
          </div>

          {/* 主内容：双栏布局 */}
          <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8 items-stretch">
            {/* 公司信息卡片 */}
            <div className="bg-white rounded-3xl shadow-xl p-8 md:p-10 border border-gray-100 mb-12">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 text-gray-700">
                <InfoItem label="公司全称" value="西航投（云南）新能源有限公司" />
                <InfoItem label="法定代表人" value="丁冬梅" />
                <InfoItem label="注册资本" value="39,860万元人民币" />
                <InfoItem label="邮政编码" value="650000" />
                <div className="md:col-span-2">
                  <div className="font-semibold text-gray-900 mb-3 text-base md:text-lg">注册地址</div>
                  <div className="text-base md:text-lg leading-relaxed">
                    云南省昆明市西山区西苑街道办事处秋苑二期2组团22幢2单元第4层403号
                  </div>
                </div>
                <div className="md:col-span-2 flex flex-col sm:flex-row sm:items-center gap-4">
                  <div>
                    <div className="font-semibold text-gray-900 mb-2 text-base md:text-lg">电子邮箱</div>
                    <div className="text-base md:text-lg">452081898@qq.com</div>
                  </div>
                </div>
                <div className="md:col-span-2">
                  <div className="font-semibold text-gray-900 mb-2 text-base md:text-lg">办公时间</div>
                  <div className="text-base md:text-lg">周一至周五 9:00 - 18:00（法定节假日除外）</div>
                </div>
              </div>
            </div>

            {/* 右侧：常见问题与合作投递 */}
            <div className="flex flex-col h-full gap-8">
              <div className="bg-gradient-to-br from-emerald-50 to-purple-50 rounded-3xl shadow-xl p-8 md:p-10 border border-emerald-100 mb-0 flex-1 flex flex-col">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">常见问题</h3>
              <div className="space-y-4 text-gray-700">
                <div>
                  <div className="font-semibold text-gray-900 mb-1">如何进行业务咨询？</div>
                  <div className="text-lg">请将需求发送至邮箱：452081898@qq.com，我们会尽快回复。</div>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">如何申请成为入围供应商？</div>
                  <div className="text-lg">请在“入围供应商”页面点击“立即申请”，按提示完成支付并提交资料。</div>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">审核周期与通知方式</div>
                  <div className="text-lg">通常 15 个工作日完成审核，结果将通过邮箱通知。</div>
                </div>
              </div>
            </div>

            {/* 合作与投递卡片 */}
            <div className="bg-gradient-to-br from-indigo-50 to-pink-50 rounded-3xl shadow-xl p-8 md:p-10 border border-indigo-100 flex-1 flex flex-col">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">合作与投递</h3>
              <div className="space-y-4 text-gray-700">
                <div>
                  <div className="font-semibold text-gray-900 mb-1">投递邮箱</div>
                  <div className="text-lg">452081898@qq.com</div>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">供应商入围申请</div>
                  <div className="text-lg">请前往入围供应商页面，完整填写申请并提交。</div>
                </div>
                <div className="text-center mt-auto pt-4">
                  <button onClick={() => setCurrentPage('suppliers')} className="bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition">
                    前往入围供应商
                  </button>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </main>

      <Footer currentPage="contact" setCurrentPage={setCurrentPage} />
    </div>
  );
};

// 子组件：信息项
const InfoItem = ({ label, value }) => (
  <div>
    <div className="font-semibold text-gray-900 mb-2 text-base md:text-lg">{label}</div>
    <div className="text-base md:text-lg">{value}</div>
  </div>
);

// 子组件：交通项
const TransportItem = ({ title, desc }) => (
  <div className="flex flex-col sm:flex-row sm:items-start gap-4">
    <div className="flex-shrink-0 w-16 py-1 bg-blue-50 text-blue-700 font-semibold rounded-lg text-center">
      {title}
    </div>
    <div className="text-lg">{desc}</div>
  </div>
);

export default ContactPage;